import React from 'react';
import PropTypes from 'prop-types';
import PlanDetailsTable from './PlanDetailsTable';
import useServicePlanTiers from '../../hooks/useServicePlanTiers/useServicePlanTiers';

function PlanDetailsTableConnected({
  selectable,
  currentPlanId,
  selectedPlanId,
  onSelectPlan,
}) {
  const { tiers, tiersLoading, tiersError } = useServicePlanTiers();

  if (tiersLoading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <div className="spinner-border text-primary" />
      </div>
    );
  }

  if (tiersError) {
    return (
      <div className="alert alert-danger m-3">
        {tiersError}
        <button
          type="button"
          className="btn btn-sm btn-outline-danger ms-3"
          onClick={() => window.location.reload()}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="container-fluid py-3">
      <PlanDetailsTable
        plans={tiers}
        selectable={selectable}
        currentPlanId={currentPlanId}
        selectedPlanId={selectedPlanId}
        onSelectPlan={onSelectPlan}
      />
    </div>
  );
}

PlanDetailsTableConnected.propTypes = {
  selectable: PropTypes.bool,
  currentPlanId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selectedPlanId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onSelectPlan: PropTypes.func,
};

PlanDetailsTableConnected.defaultProps = {
  selectable: false,
  currentPlanId: null,
  selectedPlanId: null,
  onSelectPlan: null,
};

export default PlanDetailsTableConnected;
